import React, { useState } from 'react'
import cx from 'classnames'
import styles from './DropInput.module.css'
import { v4 as uuid } from 'uuid'
import noImage from './assets/noImage.svg'
import DropInputSvg from './DropInputSvg'

type DropInputProps = {
    accept: string
    previewSrc?: string
    onFileChange?: (file: File) => void
    onBase64Change?: (base64: string) => void
    className?: string
    disabled?: boolean
}

const DropInput: React.FC<DropInputProps> = ({
    onFileChange,
    previewSrc,
    accept,
    onBase64Change,
    className,
    disabled = false,
}) => {
    const [id] = useState<string>(uuid())

    const readImage = (file: File) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        return new Promise((resolve) => {
            reader.onloadend = () => {
                resolve(reader.result)
            }
        })
    }

    const triggerEvents = (file: File) => {
        if (onFileChange) {
            onFileChange(file)
        }
        if (onBase64Change) {
            readImage(file).then((base64) => {
                onBase64Change(base64 as string)
            })
        }
    }

    const handleDrop = (event: React.DragEvent) => {
        event.preventDefault()
        const droppedFiles = event.dataTransfer.files
        if (droppedFiles.length > 0) {
            triggerEvents(droppedFiles[0])
            event.dataTransfer.clearData()
        }
    }

    const handleChange = (event: React.ChangeEvent) => {
        if (event.target instanceof HTMLInputElement) {
            const selectedFiles = event.target.files
            if (selectedFiles && selectedFiles.length > 0) {
                triggerEvents(selectedFiles[0])
                event.target.value = ''
            }
        }
    }

    return (
        <>
            <label htmlFor={'image_upload_edit_' + id} className={className}>
                <div
                    className={cx(
                        styles['drop-container'],
                        disabled ? styles['default-cursor'] : ''
                    )}
                    onDrop={handleDrop}
                    onDragOver={(event) => event.preventDefault()}
                >
                    {!previewSrc ? (
                        <div
                            className={'zr-w-100 zr-d-flex zr-justify-center'}
                            style={{ width: '100%', aspectRatio: 1 }}
                        >
                            <DropInputSvg
                                width={'100%'}
                                text={'Datei auswählen'}
                            />
                        </div>
                    ) : (
                        <img
                            style={{ objectFit: 'contain', width: '100%' }}
                            src={previewSrc}
                            alt="Preview"
                        />
                    )}
                </div>
            </label>
            <input
                disabled={disabled}
                onChange={handleChange}
                style={{ display: 'none' }}
                type="file"
                id={'image_upload_edit_' + id}
                name="file"
                accept={accept}
            />
        </>
    )
}

export default DropInput
